// Plugin copied from https://github.com/Alex-D/Trumbowyg/issues/926#issuecomment-609629806 and modified
(($) => {
  'use strict';

  $.extend(true, $.trumbowyg, {
    plugins: {
      mentionAts: {
        init: (trumbowyg) => init(trumbowyg)
      }
    }
  });
})(jQuery);

$(document).on('mouseup', (e) => {
  const container = $('.mentionPopup:visible');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    hideMention();
  }
});

const ucfirst = (cadena) => {
  if (!cadena) return cadena;
  return cadena.charAt(0).toUpperCase() + cadena.slice(1);
};

const init = (trumbowyg) => {
  const mentionList = trumbowyg.o.mentionsData;
  const $mentionPopup = $('<div class="mention-popup"></div>').hide();

  $(() => {
    $mentionPopup.insertAfter(trumbowyg.$edBox);

    // watch @ usage while typing
    trumbowyg.$ed.on('keyup', (event) => {
      const prevWord = GetPrevWord(event.target);
      let text = prevWord.substring(prevWord.indexOf('@'));

      if (text.substring(0, 1) === '@' && text.length > 0) {
        let revText = reverseString(text);
        revText = revText.substring(0, revText.indexOf('@'));
        text = reverseString(revText);
        text = text.toLowerCase();

        const mentionFiltered = mentionList
          .filter((el) => el.id.toLowerCase().indexOf(text) === 0)
          .sort((a, b) => a.id.localeCompare(b.id));

        $mentionPopup.empty().hide();
        mentionFiltered.forEach((entry) => {
          const entryName = entry.id.split('|')[0];
          const firstupper = entryName[0] === entryName[0].toUpperCase() ? 1 : 0;
          let formatEntryName = entryName;

          const re = new RegExp(text, 'i');
          if (text.length > 0) {
            formatEntryName = entryName.replace(re, `<u>${text}</u>`);
          }

          if (formatEntryName.indexOf('<') === 0 && firstupper === 1) {
            formatEntryName = ucfirst(formatEntryName.substring(3));
            formatEntryName = `<u>${formatEntryName}`;
          }
          const avatar = `<div class="avatar-wrapper"><div class="avatar"><img src='${entry.image}' /></div></div>`;
          const fullName = `<p class="mb-0 is-grey">${entry.fullname ? entry.fullname : entry.name}</p>`;
          const option = $(
            `<div class="mentionli">${avatar}<div><strong>${formatEntryName}</strong>${fullName}</div></div>`
          ).on("click", () =>
            addMention(trumbowyg, entryName, text)
          );
          $mentionPopup.show().append(option);
        });

        const coords = getSelectionCoords(trumbowyg.$edBox.get(0), trumbowyg.$btnPane.get(0), $mentionPopup.get(0));
        $mentionPopup.css({
          left: `${coords.x - 20}px`,
          top: `${coords.y + 20}px`,
        });
      } else {
        hideMention();
      }
    });
  });
};

const addMention = (trumbowyg, entryName, text) => {
  hideMention();

  trumbowyg.$ta.trumbowyg('restoreRange');
  const sel = window.getSelection();
  sel.collapseToStart();
  for (let i = 0; i <= text.length; i++) sel.modify("move", "backward", "character");
  for (let i = 0; i <= text.length; i++) sel.modify("extend", "forward", "character");

  trumbowyg.execCmd('insertHTML', `@${entryName}&nbsp;`);
}

const hideMention = () => $('.mention-popup').hide();

const GetPrevWord = (element) => {
  const text = $(element);
  const content = text.text();

  const caretPos = getCaretCharacterOffsetWithin(element);

  const word = ReturnWord(content, caretPos);

  if (word != null) {
    return word;
  }
};

const ReturnWord = (text, caretPos) => {
  const preText = text.substring(0, caretPos);
  if (preText.indexOf(' ') > 0) {
    const words = preText.split(' ');
    return words[words.length - 1]; // return last word
  } else {
    return preText;
  }
};

const reverseString = (str) => {
  return str.split('').reverse().join('');
};

const getSelectionCoords = (editableElement, panelElement, mentionPopup) => {
  const selection = window.getSelection();
  let x = 0, y = 0;

  if (selection.rangeCount) {
    const range = selection.getRangeAt(0).cloneRange();
    range.collapse(true);
    const selectionRect = range.getBoundingClientRect();
    const editableElementRect = editableElement.getBoundingClientRect()
    const mentionPopupRect = mentionPopup.getBoundingClientRect()
    const panelElementRect = panelElement.getBoundingClientRect()

    x = editableElementRect.right < selectionRect.left + mentionPopupRect.width ?
      editableElementRect.right - editableElementRect.left - mentionPopupRect.width :
      selectionRect.left - editableElementRect.left
    y = selectionRect.top + panelElementRect.height - editableElementRect.top
  }

  return { x, y };
};

const getCaretCharacterOffsetWithin = (element) => {
  let caretOffset = 0;
  const doc = element.ownerDocument || element.document;
  const win = doc.defaultView || doc.parentWindow;

  if (win.getSelection().rangeCount > 0) {
    const range = win.getSelection().getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    caretOffset = preCaretRange.toString().length;
  }

  return caretOffset;
};
